export default class CommissionRun {
  constructor(obj) {
    this.id = obj.id ? obj.id : 0;
    this.runId = obj.runId;
    this.dateFrom = obj.dateFrom;
    this.dateTo = obj.dateTo;
    this.dateIssued = obj.dateIssued;
    this.runType = obj.runType ? obj.runType : 1;
    this.statementFrom = obj.statementFrom;
    this.statementTo = obj.statementTo;
    this.approvedToPay = obj.approvedToPay ? obj.approvedToPay : false;
    this.amount = obj.amount ? obj.amount : 0.0;
  }
}
